import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import { ErrorContainer } from '../ErrorContainer';
import { DlmsUser } from './globalModels/user/dlmsUser';
import { useNavWithRouting } from './routes/AppRouter';
import { AppToaster, useAuth } from '@cksoftware/react-base';
import { ChakraRootProvider } from './components/ui/provider';
import { ProfileSelect } from './util/profiles/profileSelect';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: true
    }
  }
});

export const App = () => {
  const { initUser, hasLoaded } = useAuth<DlmsUser>();
  const AppRouter = createBrowserRouter(useNavWithRouting());

  useEffect(() => {
    async function initAuth() {
      await initUser();
    }

    initAuth();
  }, []);

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <ChakraRootProvider>
          <AppToaster />
          <ProfileSelect />
          <ErrorContainer>{hasLoaded && <RouterProvider router={AppRouter} />}</ErrorContainer>
        </ChakraRootProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </div>
  );
};
